// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "receipt_payload.proto" (package "receipt", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message receipt.ReceiptPositionPb
 */
export interface ReceiptPositionPb {
    /**
     * @generated from protobuf field: double vat = 1;
     */
    vat: number;
    /**
     * @generated from protobuf field: int32 amount = 2;
     */
    amount: number;
    /**
     * @generated from protobuf field: string title = 3;
     */
    title: string;
    /**
     * @generated from protobuf field: int32 base_price_cents = 4;
     */
    basePriceCents: number;
    /**
     * @generated from protobuf field: int32 gross_value_cents = 5;
     */
    grossValueCents: number;
}
/**
 * @generated from protobuf message receipt.ReceiptPb
 */
export interface ReceiptPb {
    /**
     * @generated from protobuf field: int32 version = 1;
     */
    version: number;
    /**
     * @generated from protobuf field: string organization_name = 2;
     */
    organizationName: string;
    /**
     * @generated from protobuf field: string organization_street = 3;
     */
    organizationStreet: string;
    /**
     * @generated from protobuf field: string organization_street_number = 4;
     */
    organizationStreetNumber: string;
    /**
     * @generated from protobuf field: string organization_postal_code = 5;
     */
    organizationPostalCode: string;
    /**
     * @generated from protobuf field: string organization_town = 6;
     */
    organizationTown: string;
    /**
     * @generated from protobuf field: string organization_tax_number = 7;
     */
    organizationTaxNumber: string;
    /**
     * @generated from protobuf field: string organization_tax_identification_number = 8;
     */
    organizationTaxIdentificationNumber: string;
    /**
     * @generated from protobuf field: int32 document_start_time_unix = 9;
     */
    documentStartTimeUnix: number;
    /**
     * @generated from protobuf field: int32 time_first_order_unix = 10;
     */
    timeFirstOrderUnix: number;
    /**
     * @generated from protobuf field: int32 receipt_number = 11;
     */
    receiptNumber: number;
    /**
     * @generated from protobuf field: string actor_name = 12;
     */
    actorName: string;
    /**
     * @generated from protobuf field: repeated receipt.ReceiptPositionPb positions = 13;
     */
    positions: ReceiptPositionPb[];
    /**
     * @generated from protobuf field: int32 total_gross_value_cents = 14;
     */
    totalGrossValueCents: number;
    /**
     * @generated from protobuf field: int32 payed_gross_value_cents = 15;
     */
    payedGrossValueCents: number;
    /**
     * @generated from protobuf field: receipt.PaymentMethodPb payment_method = 16;
     */
    paymentMethod: PaymentMethodPb;
    /**
     * @generated from protobuf field: string tse_qr_code_content = 17;
     */
    tseQrCodeContent: string;
}
/**
 * @generated from protobuf enum receipt.PaymentMethodPb
 */
export enum PaymentMethodPb {
    /**
     * @generated from protobuf enum value: CASH = 0;
     */
    CASH = 0,
    /**
     * @generated from protobuf enum value: CARD = 1;
     */
    CARD = 1,
    /**
     * @generated from protobuf enum value: NONE = 2;
     */
    NONE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class ReceiptPositionPb$Type extends MessageType<ReceiptPositionPb> {
    constructor() {
        super("receipt.ReceiptPositionPb", [
            { no: 1, name: "vat", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "amount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "base_price_cents", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "gross_value_cents", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ReceiptPositionPb>): ReceiptPositionPb {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vat = 0;
        message.amount = 0;
        message.title = "";
        message.basePriceCents = 0;
        message.grossValueCents = 0;
        if (value !== undefined)
            reflectionMergePartial<ReceiptPositionPb>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReceiptPositionPb): ReceiptPositionPb {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double vat */ 1:
                    message.vat = reader.double();
                    break;
                case /* int32 amount */ 2:
                    message.amount = reader.int32();
                    break;
                case /* string title */ 3:
                    message.title = reader.string();
                    break;
                case /* int32 base_price_cents */ 4:
                    message.basePriceCents = reader.int32();
                    break;
                case /* int32 gross_value_cents */ 5:
                    message.grossValueCents = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReceiptPositionPb, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double vat = 1; */
        if (message.vat !== 0)
            writer.tag(1, WireType.Bit64).double(message.vat);
        /* int32 amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Varint).int32(message.amount);
        /* string title = 3; */
        if (message.title !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* int32 base_price_cents = 4; */
        if (message.basePriceCents !== 0)
            writer.tag(4, WireType.Varint).int32(message.basePriceCents);
        /* int32 gross_value_cents = 5; */
        if (message.grossValueCents !== 0)
            writer.tag(5, WireType.Varint).int32(message.grossValueCents);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message receipt.ReceiptPositionPb
 */
export const ReceiptPositionPb = new ReceiptPositionPb$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReceiptPb$Type extends MessageType<ReceiptPb> {
    constructor() {
        super("receipt.ReceiptPb", [
            { no: 1, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organization_street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "organization_street_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "organization_postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "organization_town", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "organization_tax_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "organization_tax_identification_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "document_start_time_unix", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "time_first_order_unix", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "receipt_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "actor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "positions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ReceiptPositionPb },
            { no: 14, name: "total_gross_value_cents", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "payed_gross_value_cents", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "payment_method", kind: "enum", T: () => ["receipt.PaymentMethodPb", PaymentMethodPb] },
            { no: 17, name: "tse_qr_code_content", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReceiptPb>): ReceiptPb {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.version = 0;
        message.organizationName = "";
        message.organizationStreet = "";
        message.organizationStreetNumber = "";
        message.organizationPostalCode = "";
        message.organizationTown = "";
        message.organizationTaxNumber = "";
        message.organizationTaxIdentificationNumber = "";
        message.documentStartTimeUnix = 0;
        message.timeFirstOrderUnix = 0;
        message.receiptNumber = 0;
        message.actorName = "";
        message.positions = [];
        message.totalGrossValueCents = 0;
        message.payedGrossValueCents = 0;
        message.paymentMethod = 0;
        message.tseQrCodeContent = "";
        if (value !== undefined)
            reflectionMergePartial<ReceiptPb>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReceiptPb): ReceiptPb {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 version */ 1:
                    message.version = reader.int32();
                    break;
                case /* string organization_name */ 2:
                    message.organizationName = reader.string();
                    break;
                case /* string organization_street */ 3:
                    message.organizationStreet = reader.string();
                    break;
                case /* string organization_street_number */ 4:
                    message.organizationStreetNumber = reader.string();
                    break;
                case /* string organization_postal_code */ 5:
                    message.organizationPostalCode = reader.string();
                    break;
                case /* string organization_town */ 6:
                    message.organizationTown = reader.string();
                    break;
                case /* string organization_tax_number */ 7:
                    message.organizationTaxNumber = reader.string();
                    break;
                case /* string organization_tax_identification_number */ 8:
                    message.organizationTaxIdentificationNumber = reader.string();
                    break;
                case /* int32 document_start_time_unix */ 9:
                    message.documentStartTimeUnix = reader.int32();
                    break;
                case /* int32 time_first_order_unix */ 10:
                    message.timeFirstOrderUnix = reader.int32();
                    break;
                case /* int32 receipt_number */ 11:
                    message.receiptNumber = reader.int32();
                    break;
                case /* string actor_name */ 12:
                    message.actorName = reader.string();
                    break;
                case /* repeated receipt.ReceiptPositionPb positions */ 13:
                    message.positions.push(ReceiptPositionPb.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_gross_value_cents */ 14:
                    message.totalGrossValueCents = reader.int32();
                    break;
                case /* int32 payed_gross_value_cents */ 15:
                    message.payedGrossValueCents = reader.int32();
                    break;
                case /* receipt.PaymentMethodPb payment_method */ 16:
                    message.paymentMethod = reader.int32();
                    break;
                case /* string tse_qr_code_content */ 17:
                    message.tseQrCodeContent = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReceiptPb, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 version = 1; */
        if (message.version !== 0)
            writer.tag(1, WireType.Varint).int32(message.version);
        /* string organization_name = 2; */
        if (message.organizationName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.organizationName);
        /* string organization_street = 3; */
        if (message.organizationStreet !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.organizationStreet);
        /* string organization_street_number = 4; */
        if (message.organizationStreetNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.organizationStreetNumber);
        /* string organization_postal_code = 5; */
        if (message.organizationPostalCode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.organizationPostalCode);
        /* string organization_town = 6; */
        if (message.organizationTown !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.organizationTown);
        /* string organization_tax_number = 7; */
        if (message.organizationTaxNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.organizationTaxNumber);
        /* string organization_tax_identification_number = 8; */
        if (message.organizationTaxIdentificationNumber !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.organizationTaxIdentificationNumber);
        /* int32 document_start_time_unix = 9; */
        if (message.documentStartTimeUnix !== 0)
            writer.tag(9, WireType.Varint).int32(message.documentStartTimeUnix);
        /* int32 time_first_order_unix = 10; */
        if (message.timeFirstOrderUnix !== 0)
            writer.tag(10, WireType.Varint).int32(message.timeFirstOrderUnix);
        /* int32 receipt_number = 11; */
        if (message.receiptNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.receiptNumber);
        /* string actor_name = 12; */
        if (message.actorName !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.actorName);
        /* repeated receipt.ReceiptPositionPb positions = 13; */
        for (let i = 0; i < message.positions.length; i++)
            ReceiptPositionPb.internalBinaryWrite(message.positions[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_gross_value_cents = 14; */
        if (message.totalGrossValueCents !== 0)
            writer.tag(14, WireType.Varint).int32(message.totalGrossValueCents);
        /* int32 payed_gross_value_cents = 15; */
        if (message.payedGrossValueCents !== 0)
            writer.tag(15, WireType.Varint).int32(message.payedGrossValueCents);
        /* receipt.PaymentMethodPb payment_method = 16; */
        if (message.paymentMethod !== 0)
            writer.tag(16, WireType.Varint).int32(message.paymentMethod);
        /* string tse_qr_code_content = 17; */
        if (message.tseQrCodeContent !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.tseQrCodeContent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message receipt.ReceiptPb
 */
export const ReceiptPb = new ReceiptPb$Type();
